export const APP_ROUTES_V2 = {
  DASHBOARD: "/",

  CUSTOMER_EXPERIENCES: {
    ROOT: "/customer-experiences",
    MARKETPLACE: "/customer-experiences/marketplace",
    SHOP: "/customer-experiences/shop",
  },

  NOTIFICATIONS: {
    ROOT: "/notifications",

    // New notification preview routes with encoded IDs
    NOTIFICATION_PREVIEW: "/notifications/:encodedId/preview",
    NOTIFICATION_EDIT: "/notifications/:encodedId/edit",

    CUSTOMER: {
      ROOT: "/notifications/customer",
      PREORDERS: {
        ROOT: "/notifications/customer/pre-order",
        EMAIL: "/notifications/customer/pre-order/email",
        SMS: "/notifications/customer/pre-order/sms",
        SHIPPING_EMAIL: "/notifications/customer/pre-order/shipping-email",
      },
      BACKINSTOCK: {
        ROOT: "/notifications/customer/back-in-stock",
        EMAIL: "/notifications/customer/back-in-stock/email",
      },
    },

    STAFF: {
      ROOT: "/notifications/staff",
      PREORDERS: {
        ROOT: "/notifications/staff/pre-order",
        EMAIL: "/notifications/staff/pre-order/email",

        SMS: "/notifications/staff/pre-order/sms",
        SHIPPING_EMAIL: "/notifications/staff/pre-order/shipping-email",
      },
      BACKINSTOCK: {
        ROOT: "/notifications/staff/back-in-stock",
        EMAIL: "/notifications/staff/back-in-stock/email",
      },
    },
  },
  PRODUCTS: {
    ROOT: "/products",
    SELECTION: "/products/selection",
    SELECTION_CONFIG: "/products/selection/configuration",
    VARIANT_DETAIL: "/products/:encodedId/variants/:variantId",
    CSV: "/products/csv",
  },

  REPORTS: {
    ROOT: "/reports",
    PREORDER: {
      ROOT: "/reports/preorder",
      SALES: "/reports/preorder/sales",
      TOP_PRODUCTS: "/reports/preorder/top-products",
      TRAFFIC_SOURCE: "/reports/preorder/traffic-source",
      NOTIFICATIONS: "/reports/preorder/notifications",
      PARTIAL_PAYMENT: "/reports/preorder/partial-payment",
    },
    NOTIFY_ME: {
      ROOT: "/reports/notify-me",
      TRENDS: "/reports/notify-me/trends",
      CONVERSIONS: "/reports/notify-me/conversions",
      TRAFFIC_INSIGHTS: "/reports/notify-me/traffic-insights",
      TOP_PRODUCTS: "/reports/notify-me/top-products",
    },
  },

  CUSTOMERS: "/customers",

  ACCOUNT: "/account",

  ORDERS: {
    ROOT: "/orders",
    DETAIL: "/orders/:encodedId",
  },
};

export const DATABASE_STATUTES = {
  NOT_LOADED: "NOT_LOADED",
  LOADING: "LOADING",
  LOADED: "LOADED",
  LOADED_ERROR: "LOADED_ERROR",
  IN_PROGRESS: "IN_PROGRESS",
};

// Dashboard

export const TIMESACT_ONBOARDING_URL = "https://calendly.com/timesact_onboarding/30min";
export const TIMESACT_HELP_CENTER_URL = "https://help.timesact.com";
export const TIMESACT_TUTORIAL_URL = "https://www.youtube.com/@timesact/videos";

// Documentation URLs
export const DOCS_URLS = {
  DYNAMIC_VARIABLES: "https://help.timesact.com/en/articles/dynamic-variables",
  CUSTOMER_EXPERIENCES: "https://help.timesact.com/en/articles/customer-experiences",
  TRANSLATIONS: "https://help.timesact.com/en/articles/translations",
};

const SUPPORT_EMAIL_SUBJECT = "Help with the app";
const SUPPORT_EMAIL_BODY = "The message’s first paragraph.%0A%0ASecond paragraph.%0A%0AThird Paragraph.";
export const SUPPORT_EMAIL = "support@timesact.com";
export const SUPPORT_EMAIL_LINK = `mailto:${SUPPORT_EMAIL}?subject=${SUPPORT_EMAIL_SUBJECT}&body=${SUPPORT_EMAIL_BODY}`;
// PRODUCTS
export const DEFAULT_PRODUCT_FILTER_VALUES = {
  startDate: {
    from: null,
    to: null,
  },
  customerExperience: "",
  vendors: [],
  tags: [],
  feature: "",
  featureStatus: "",
};

// Account

export const CORE = "CORE";
export const PRO = "PRO";

export const FREE = "FREE";
export const FLEXIBLE = "FLEXIBLE";
export const FIXED = "FIXED";

export const PLAN_OPTION_DESCRIPTION_TRANSLATION_KEYMAP = {
  CORE_FREE: "account.planCards.description.core.free",
  CORE_FLEXIBLE: "account.planCards.description.core.flexible",
  CORE_FIXED: "account.planCards.description.core.fixed",
  PRO_FLEXIBLE: "account.planCards.description.pro.flexible",
  PRO_FIXED: "account.planCards.description.pro.fixed",
};

export const PLAN_FEATURES_INCLUDED = {
  CORE_FREE: [
    "account.planCards.features.core.free.orders",
    "account.planCards.features.core.experiences-label",
    "account.planCards.features.support",
    "account.planCards.features.onboarding",
  ],
  CORE_FLEXIBLE: [
    "account.planCards.features.core.flexible.orders",
    "account.planCards.features.core.flexible.additional-cost",
    "account.planCards.features.core.experiences-label",
    "account.planCards.features.support",
    "account.planCards.features.onboarding",
  ],
  CORE_FIXED: [
    "account.planCards.features.core.fixed.orders",
    "account.planCards.features.core.fixed.additional-cost",
    "account.planCards.features.core.experiences-label",
    "account.planCards.features.support",
    "account.planCards.features.onboarding",
  ],
  PRO_FLEXIBLE: [
    "account.planCards.features.pro.flexible.orders",
    "account.planCards.features.pro.flexible.additional-cost",
    "account.planCards.features.pro.experiences-label",
    "account.planCards.features.support",
    "account.planCards.features.onboarding",
  ],
  PRO_FIXED: [
    "account.planCards.features.pro.fixed.orders",
    "account.planCards.features.pro.fixed.additional-cost",
    "account.planCards.features.pro.experiences-label",
    "account.planCards.features.support",
    "account.planCards.features.onboarding",
  ],
};

// Reports
export const DEFAULT_BACK_IN_STOCK_FILTER_VALUES = {
  status: [],
};

export const BACK_IN_STOCK_STATUSES = ["PENDING", "SENT", "DELIVERED", "DEFERRED", "FAILED", "BLOCKED", "BOUNCED"];

export const BACK_IN_STOCK_TABS = [
  { id: "all", content: "All", value: null },
  { id: "pending", content: "Pending", value: "PENDING" },
  { id: "delivered", content: "Delivered", value: "DELIVERED" },
];

// Email Logs
export const EMAIL_LOG_STATUSES = ["PENDING", "SENT", "DELIVERED", "DEFERRED", "FAILED", "BLOCKED", "BOUNCED"];

export const EMAIL_LOG_EMAIL_TYPES = ["CONFIRMATION", "SHIPPING_DELAY"];

export const EMAIL_LOG_TABS = [
  { id: "all", content: "All", value: null },
  { id: "confirmation", content: "Confirmation", value: "CONFIRMATION" },
  { id: "shipping-delay", content: "Shipping Delay", value: "SHIPPING_DELAY" },
];

// Orders
export const ORDER_FINANCIAL_STATUSES = [
  "AUTHORIZED",
  "EXPIRED",
  "PAID",
  "PARTIALLY_PAID",
  "PARTIALLY_REFUNDED",
  "PENDING",
  "REFUNDED",
  "VOIDED",
];

export const ORDER_FULFILLMENT_STATUSES = [
  "OPEN",
  "ON_HOLD",
  "IN_PROGRESS",
  "PENDING_FULFILLMENT",
  "PARTIALLY_FULFILLED",
  "FULFILLED",
  "UNFULFILLED",
  "RESTOCKED",
  "SCHEDULED",
  "REQUEST_DECLINED",
];

export const ORDER_TABS = [
  { id: "all", content: "All", value: null },
  { id: "unfulfilled", content: "Unfulfilled", value: "UNFULFILLED", filterType: "fulfillmentStatus" },
  { id: "scheduled", content: "Scheduled", value: "SCHEDULED", filterType: "fulfillmentStatus" },
  { id: "hold", content: "Hold", value: "ON_HOLD", filterType: "fulfillmentStatus" },
  { id: "paid", content: "Paid", value: "PAID", filterType: "financialStatus" },
  { id: "partially_paid", content: "Partially Paid", value: "PARTIALLY_PAID", filterType: "financialStatus" },
];

// Products

export const PRODUCTS_TABS = [
  { id: "all", value: null, content: "All" },
  { id: "preorder", value: "PREORDER", content: "Pre-order" },
  { id: "backinstock", value: "BACKINSTOCK", content: "Back in stock" },
  { id: "comingsoon", value: "COMINGSOON", content: "Coming soon" },
  { id: "lowstock", value: "LOWSTOCK", content: "Low stock" },
];

export const FEATURE_STATUS_OPTIONS = [
  { label: "Active", value: "ACTIVE" },
  { label: "Pending", value: "PENDING" },
  { label: "Pending Start Date", value: "PENDING_START_DATE" },
  { label: "Processing", value: "PROCESSING" },
  { label: "No Stock", value: "NO_STOCK" },
  { label: "Expired", value: "EXPIRED" },
];

// Products table column configuration
export const PRODUCTS_TABLE_COLUMNS = {
  customerExperience: { id: "customerExperience", title: "Customer Experience", alignment: "center" },
  startEndDate: { id: "startEndDate", title: "Start - End date", alignment: "center" },
  featuresStatuses: { id: "featuresStatuses", title: "Features Statuses", alignment: "center" },
  preOrderQuantity: { id: "preOrderQuantity", title: "Pre-order Qty", alignment: "center" },
  preOrderSold: { id: "preOrderSold", title: "Pre-order Sold", alignment: "center" },
  inventoryQuantity: { id: "inventoryQuantity", title: "Inventory Qty", alignment: "center" },
  bisThreshold: { id: "bisThreshold", title: "BIS Threshold", alignment: "center" },
  lowStockThreshold: { id: "lowStockThreshold", title: "Low Stock Threshold", alignment: "center" },
  price: { id: "price", title: "Price", alignment: "end" },
};

// Default columns for each tab
export const DEFAULT_COLUMNS_BY_TAB = {
  all: ["customerExperience", "startEndDate", "featuresStatuses"],
  PREORDER: [
    "customerExperience",
    "startEndDate",
    "preOrderQuantity",
    "preOrderSold",
    "inventoryQuantity",
    "featuresStatuses",
  ],
  BACKINSTOCK: ["customerExperience", "startEndDate", "bisThreshold", "inventoryQuantity", "featuresStatuses"],
  COMINGSOON: ["customerExperience", "startEndDate", "featuresStatuses"],
  LOWSTOCK: ["customerExperience", "lowStockThreshold", "inventoryQuantity", "featuresStatuses"],
};
